import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseIps from '../../AbstractObjects/GatewayPlan/InnerPages/BaseIps';

const pageSchema = PlanGetSchema.pages.ips;
const pageId = pageSchema.pageId;

function PlanIps({
    planObject,
    setPlanData,
    setEditorPageId
}) {
    const pageData = planObject[pageId];

    return (
        <BaseIps
            pageData={pageData}
            setObjectData={setPlanData}
            setEditorPageId={setEditorPageId}
        />
    );
}

export default PlanIps;